
import { useContext } from 'react';

import { RedirectContext } from 'context/Redirect';
import { TrackingContext } from 'context/Tracking';
import { UserContext } from 'context/User';

export function useMfaRedirect() {
  const [, { faro }] = useContext(TrackingContext);
  const [, { getUser, setUser }] = useContext(UserContext);
  const [
    { customContent, instance, to },
    { redirectToCustomLoginRedirect, redirectToPortal, redirectToStateInstanceHome, redirectToTo },
  ] = useContext(RedirectContext);

  const redirectAfterSuccess = async () => {
    try {
      const userData = await getUser();
      await setUser(userData);

      const hasOrgs = (userData?.memberships.length ?? 0) > 0;
      if (customContent?.loginRedirect && (hasOrgs || customContent.skipOrgCreation)) {
        redirectToCustomLoginRedirect();
      } else if (to) {
        redirectToTo();
      } else if (instance) {
        redirectToStateInstanceHome();
      } else {
        redirectToPortal(userData);
      }
    } catch (err) {
      faro.trackError(err as Error);
      redirectToPortal(null);
    }
  };

  return redirectAfterSuccess;
}
